(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-custom-reviews"] && !Shopify.designMode) return;
  try {
    
  const DESKTOP_COLUMNS = 3;
  const MOBILE_BREAKPOINT = 750;

  class CustomReviewsPagination {
    constructor(section) {
      this.section = section;
      this.slider = section.querySelector('[data-grid-slider]');
      this.dotsContainer = section.querySelector('[data-pagination]');
      this.slides = Array.from(this.slider?.querySelectorAll('[data-grid-item]') || []);

      if (!this.slider || !this.dotsContainer || !this.slides.length) return;

      this.observer = null;
      this.onResize = this.rebuild.bind(this);
      this.isMobile = () => window.innerWidth < MOBILE_BREAKPOINT;

      this.build();
      window.addEventListener('resize', this.onResize);
    }

    build() {
      this.dotsContainer.innerHTML = '';
      const perPage = this.isMobile() ? 1 : DESKTOP_COLUMNS;
      const pageCount = Math.ceil(this.slides.length / perPage);

      if (pageCount <= 1) return;

      this.pages = [];
      for (let i = 0; i < pageCount; i++) {
        const startIndex = i * perPage;
        const dot = document.createElement('button');
        dot.classList.add('custom-reviews__dot');
        dot.addEventListener('click', () => {
          this.slider.scrollTo({ left: this.slides[startIndex].offsetLeft, behavior: 'smooth' });
        });
        this.dotsContainer.appendChild(dot);
        this.pages.push({ dot, startIndex, endIndex: Math.min(startIndex + perPage, this.slides.length) - 1 });
      }

      this.observeSlides();
    }

    observeSlides() {
      this.observer?.disconnect();

      this.observer = new IntersectionObserver(
        () => this.updateActiveDot(),
        { root: this.slider, threshold: 0.5 }
      );

      this.slides.forEach((slide) => this.observer.observe(slide));
    }

    updateActiveDot() {
      if (!this.pages) return;

      const visibleIndices = new Set();
      this.slides.forEach((slide, i) => {
        const rect = slide.getBoundingClientRect();
        const sliderRect = this.slider.getBoundingClientRect();
        const midpoint = rect.left + rect.width / 2;
        if (midpoint >= sliderRect.left && midpoint <= sliderRect.right) {
          visibleIndices.add(i);
        }
      });

      this.pages.forEach((page) => {
        const isActive = visibleIndices.has(page.startIndex);
        page.dot.classList.toggle('is-active', isActive);
      });
    }

    rebuild() {
      const wasMobile = this._wasMobile;
      this._wasMobile = this.isMobile();
      if (wasMobile !== undefined && wasMobile === this._wasMobile) return;
      this.build();
    }
  }

  document.querySelectorAll('[data-section-type="custom-reviews"]').forEach((section) => {
    new CustomReviewsPagination(section);
  });

  } catch(e) { console.error(e); }
})();
})();
